import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import getData from '../item/getData';
import ItemTabsWidget, { richTextConfigItems, tabSettingsDefault } from '../item/LandingPageTabs/ItemTabsWidget';
export const tabConfigItems = {
    about: {
        name: 'Show About Tab',
        description: 'Show the item info on the card',
        tokenKey: 'programAboutLabel',
    },
    instructors: {
        name: 'Show Instructors Tab',
        description: 'Show the instructors info on the card',
        tokenKey: 'instructorsTabLabel',
    },
    outline: {
        name: 'Show Outline Tab',
        description: 'Show the outline info on the card',
        tokenKey: 'programOutlineLabel',
    },
    discussion: {
        name: 'Show Discussion Group Tab',
        description: 'Show the discussion group.  Customer must be logged in to see this tab',
        tokenKey: 'discussionGroupLabel',
    },
    ...richTextConfigItems,
};
const ProgramTabsWidget = ({ programID, tabSettings, progressBarColor, }) => (_jsx(ItemTabsWidget, { itemType: "program", itemID: programID, tabConfigItems: tabConfigItems, tabSettings: tabSettings, progressBarColor: progressBarColor }));
ProgramTabsWidget.getChildren = ItemTabsWidget.getChildren;
ProgramTabsWidget.getData = async ({ categoryId, programID, context, tabSettings, }, store) => {
    console.log('ProgramTabsWidget.getData', { programID, tabSettings });
    // todo - could call it on the tab items to get their specific needs
    // but assume here we want to load all the sections
    const program = await store.load('program', programID);
    console.log('program got', program);
    const courseSections = program.filterSections('course');
    const microcastSections = program.filterSections('microcast');
    const items = [...courseSections, ...microcastSections].map((section) => (section.item));
    console.log('loading items', items);
    await getData({
        categoryId,
        items,
        context,
    }, store);
    console.log('loaded items', items);
};
ProgramTabsWidget.meta = {
    group: 'design',
    name: 'Program Tabs',
    description: 'Display program information in a set of tabs.',
    props: [
        {
            key: 'programID',
            name: 'Program',
            type: 'program',
            description: 'The program to display information about',
        },
        {
            key: 'tabSettings',
            name: 'Tabs',
            type: 'courseTabsConfig',
            description: 'Show and hide individual tabs as well as control tab order',
            items: tabConfigItems,
        },
        {
            key: 'progressBarColor',
            name: 'Progress Bar Color',
            type: 'color',
            description: 'Sets the color of the progress bar in the outline.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'ProgramTabs',
        props: {
            programID: '@programID',
            limitToPageWidth: true,
            tabSettings: tabSettingsDefault,
        },
    },
};
export default observer(ProgramTabsWidget);
//# sourceMappingURL=ProgramTabsWidget.js.map